<template>
  <div>
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Minha conta</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Altere ou veja os seus dados.
          </h5>
        </div>
      </v-container>
    </div>
    <v-container>
      <ProfileHeader :user="user" :loading="loading" />
      <v-tabs dark background-color="primary" v-model="tab" align-with-title>
        <v-tabs-slider color="#FFBA00"></v-tabs-slider>

        <v-tab light v-for="menuItem in menuItems" :key="menuItem.route">
          <v-icon small class="mr-2">{{ menuItem.icon }}</v-icon
          >{{ menuItem.title }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="meus-dados">
          <MeusDadosForm />
        </v-tab-item>
        <v-tab-item key="redefinir-senha">
          <RedefinirSenhaForm />
        </v-tab-item>
        <v-tab-item key="assinatura">
          <AssinaturaForm />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import userService from '@/services/user'
import ProfileHeader from '@/views/MinhaConta/components/ProfileHeader.vue'
import MeusDadosForm from '../../MeusDados/MeusDadosForm.vue'
import RedefinirSenhaForm from '../../RedefinirSenha/RedefinirSenhaForm.vue'
import AssinaturaForm from '../../Assinatura/Assinatura.vue'

export default {
  props: {
    menuItems: {
      required: true
    }
  },
  components: {
    ProfileHeader,
    MeusDadosForm,
    RedefinirSenhaForm,
    AssinaturaForm
  },
  data() {
    return {
      user: null,
      loading: false,
      tab: null
    }
  },
  methods: {
    async getUserData() {
      try {
        this.loading = true
        const { data } = await userService.show()
        this.user = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.getUserData()
  }
}
</script>

<style scoped>
.profile-menu-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  border-radius: 15px;
  padding: 15px;
  cursor: pointer;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}
.item-icon {
  width: 20%;
}
.item-name {
  width: 70%;
}
.item-action {
  width: 10%;
}
.profile-menu-itens {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
